export const ROOM_THEME_OPTIONS = [
    { value: 'brio', label: 'Brio (predeterminado)' },
    { value: 'piratas', label: 'Piratas' },
    { value: 'scifi', label: 'Sci-fi' },
    { value: 'horror', label: 'Terror gótico' },
    { value: 'cosmico', label: 'Terror cósmico' },
    { value: 'western', label: 'Western' },
    { value: 'victoriano', label: 'Victoriano' },
    { value: 'castillos', label: 'Medieval' },
    { value: 'neutro', label: 'Neutro' },
    { value: 'urbano', label: 'Urbano' },
] as const;

export type RoomTheme = (typeof ROOM_THEME_OPTIONS)[number]['value'];

export const DEFAULT_ROOM_THEME: RoomTheme = 'brio';

const ROOM_THEME_VALUES = ROOM_THEME_OPTIONS.map((o) => o.value as string);

export function isRoomTheme(value: string | null): value is RoomTheme {
    return value !== null && ROOM_THEME_VALUES.includes(value);
}
